export default function(state = null, action) {
  switch(action.type) {
    case 'GARDA_SUBDIVISION_ADDED': 
      return action.payload
  }
  return state
}


// WEBPACK FOOTER //
// ./src/reducers/garda-subdivision.js